const UNIQUE_NO_STORAGE_KEY = "client_unique_no";
const PLAYER_ID_STORAGE_KEY = "player_id";

const safeLocalStorageGet = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    return "";
  }
};

const safeLocalStorageSet = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    // localStorage can be unavailable in restricted browser contexts.
  }
};

const createFallbackUuid = () =>
  "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (token) => {
    const random = Math.floor(Math.random() * 16);
    const value = token === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });

export const getOrCreateUniqueNo = () => {
  const existingUniqueNo = safeLocalStorageGet(UNIQUE_NO_STORAGE_KEY);

  if (existingUniqueNo) {
    return existingUniqueNo;
  }

  const uniqueNo =
    typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : createFallbackUuid();

  safeLocalStorageSet(UNIQUE_NO_STORAGE_KEY, uniqueNo);
  return uniqueNo;
};

export const getOperatingSystem = () => {
  if (typeof window === "undefined") {
    return "Unknown";
  }

  const userAgent = window.navigator.userAgent || "";
  const platform = window.navigator.platform || "";

  if (/Win/i.test(platform) || /Windows/i.test(userAgent)) {
    return "Windows";
  }

  if (/Mac/i.test(platform)) {
    return "macOS";
  }

  if (/Android/i.test(userAgent)) {
    return "Android";
  }

  if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return "iOS";
  }

  if (/Linux/i.test(platform)) {
    return "Linux";
  }

  return "Unknown";
};

export const getBrowserName = () => {
  if (typeof window === "undefined") {
    return "Unknown";
  }

  const userAgent = window.navigator.userAgent || "";

  if (/Edg\//i.test(userAgent)) {
    return "Edge";
  }

  if (/OPR\//i.test(userAgent)) {
    return "Opera";
  }

  if (/Chrome\//i.test(userAgent) && !/Chromium/i.test(userAgent)) {
    return "Chrome";
  }

  if (/Firefox\//i.test(userAgent)) {
    return "Firefox";
  }

  if (/Safari\//i.test(userAgent) && !/Chrome\//i.test(userAgent)) {
    return "Safari";
  }

  return "Unknown";
};

export const buildClientContext = () => ({
  device: 2,
  operating_system: getOperatingSystem(),
  browser: getBrowserName(),
  player_id: safeLocalStorageGet(PLAYER_ID_STORAGE_KEY) || "",
  unique_no: getOrCreateUniqueNo(),
});

export const appendClientContextToFormData = (formData, clientContext = {}) => {
  Object.entries(clientContext).forEach(([key, value]) => {
    formData.append(key, value ?? "");
  });

  return formData;
};
